import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import HomeToHorizon from "@/components/HomeToHorizon";
import WhyChooseUs from "@/components/WhyChooseUs";
import PhotoGallery from "@/components/PhotoGallery";
import FounderMessage from "@/components/FounderMessage";
import Testimonials from "@/components/Testimonials";
import TrustBadges from "@/components/TrustBadges";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import StructuredData from "@/components/StructuredData";
import WhatsAppWidget from "@/components/WhatsAppWidget";
const Index = () => {
  return <div className="min-h-screen">
      <StructuredData type="organization" />
      <StructuredData type="service" />
      <StructuredData type="faq" />
      <StructuredData type="localBusiness" />
      <Header />
      <main className="pt-20">
        <section id="hero">
          <Hero />
        </section>
        <article id="about">
          <About />
        </article>
        <section id="services" aria-label="Service Plans">
          <Services />
        </section>
        <section aria-label="Journey Support">
          <HomeToHorizon />
        </section>
        <section aria-label="Why Choose Us">
          <WhyChooseUs />
        </section>
        <section aria-label="Photo Gallery">
          <PhotoGallery />
        </section>
        <section aria-label="Trust Indicators">
          <TrustBadges className="my-0 py-0" />
        </section>
        <section aria-label="Student Testimonials">
          <Testimonials />
        </section>
        <aside>
          <FounderMessage />
        </aside>
        <section id="faq" aria-label="Frequently Asked Questions">
          <FAQ />
        </section>
        <section id="contact" aria-label="Contact Form">
          <Contact />
        </section>
      </main>
      <Footer />
      <WhatsAppWidget />
    </div>;
};
export default Index;